//// https://api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
 ( function () {
    'use strict';
    jQuery.extend( true, e4.settings, {
        ecom: {
            product: {
                url: '/system/data/product'
            },
            quickorder: {
                url: '/system/data/quickorder'
            },
            download: {
                url: '/system/data/cart-download'
            },
            variants: {
                autoSelect: true
            },
            filters: {
                cleanUrl: true
            },
            vatCheck: {
                url: '/system/data/vat-check'
            }
        },
        debug: {
            show: false,
            consoleType: 'log'
        },
        debounceDelay: {
            input: 500
        },
        institutions: {
            url: '/system/data/institutions'
        }
    } );
 }() );
